import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { fadeIn, fadeInOut } from 'src/app/animations';


@Component({
  selector: 'app-inline-snackbar',
  templateUrl: './inline-snackbar.component.html',
  styleUrls: ['./inline-snackbar.component.scss'],
  animations: [fadeInOut]
})
export class InlineSnackbarComponent {
  @Input() data!: { class: 'is-success' | 'is-error', message: string };
  @Output() inlineSnackbarClose: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  close(): void {
    this.inlineSnackbarClose.emit(true);
  }

}
